/* eslint-disable curly */
import React, { Component, useRef } from "react";
import {
  StyleSheet,
  View,
  Text,
  Dimensions,
  TextInput,
  TouchableOpacity,
  Keyboard,
  Animated,
  Platform,
  KeyboardAvoidingView,
  ScrollView,
  ImageBackground,
} from "react-native";
import { StackActions } from "react-navigation";
import Icon from "react-native-vector-icons/FontAwesome";
import { EventRegister } from "react-native-event-listeners";
import styles from "./styles";

import { buscaViaCep } from "../../services/viacep-service";
import { enderecoFormat, mascaraCep } from "../../utils/formatUtils";
import Loading from "../../components/Loading";

import { atualizar as atualizarAluno } from "../../services/aluno-service";
import ButtonConfirm from "../../components/ButtonConfirm";
import { TextInputMask } from "react-native-masked-text";
import { alert } from "../../utils/alerts";

const widthScreen = Dimensions.get("screen").width;
const widthInput = "90%";

const ConfirmaEndereco = (props) => {
  const fadeAnim = useRef(new Animated.Value(0)).current;

  const fadeIn = () => {
    Animated.timing(fadeAnim, {
      toValue: 1,
      duration: 500,
      useNativeDriver: true,
    }).start();
  };

  const fadeOut = () => {
    Animated.timing(fadeAnim, {
      toValue: 0,
      duration: 500,
      useNativeDriver: true,
    }).start();
  };

  const { endereco } = props;
  if (endereco.logradouro) {
    fadeIn();
    return (
      <View style={{ width: "100%", alignItems: "center" }}>
        <Animated.View
          style={[
            styles.personalData,
            {
              opacity: fadeAnim,
              padding: 20,
            },
          ]}
        >
          <Text
            style={[styles.textHeader2, { marginTop: 0, marginBottom: 10 }]}
          >
            Esse é o seu novo endereço?
          </Text>
          <Text style={styles.dataProperty}>LOGRADOURO:</Text>
          <Text style={styles.dataValue}>{endereco.logradouro}</Text>

          <Text style={styles.dataProperty}>BAIRRO:</Text>
          <Text style={styles.dataValue}>{endereco.bairro}</Text>

          <Text style={styles.dataProperty}>MUNICÍPIO:</Text>
          <Text style={styles.dataValue}>{endereco.municipio}</Text>

          <Text style={styles.dataProperty}>ESTADO:</Text>
          <Text style={styles.dataValue}>{endereco.estado}</Text>

          <Text style={styles.alert}>
            Usamos essas informações apenas para indicar você para vagas nas
            proximidades, portanto não precisamos do número da sua residência.
          </Text>
        </Animated.View>
      </View>
    );
  } else {
    fadeOut();
    return <View></View>;
  }
};

class EditarEndereco extends Component {
  static navigationOptions = ({ navigation }) => {
    return {
      headerStyle: {
        backgroundColor: "#0F0F0F",
      },
      headerTitleStyle: {
        color: "#F1F1F1",
      },
      headerLeft: () => (
        <TouchableOpacity
          onPress={() => {
            const navigateAction = StackActions.pop(1);
            navigation.dispatch(navigateAction);
          }}
        >
          <Icon
            style={styles.iconToggle}
            name="arrow-left"
            size={20}
            color="#F1F1F1"
          />
        </TouchableOpacity>
      ),
    };
  };

  constructor(props) {
    super();
    this.state = {
      cep: "",
      endereco: {},
      showConfirm: false,
      loading: false,
    };
  }

  validado = () => {
    const { cep } = this.state;
    if (!cep) {
      alert("Ops...", "Preencha o CEP");
      return false;
    }
    return true;
  };

  buscaCep = async () => {
    if (!this.validado()) return;

    this.setState({ ...this.state, loading: true });

    const cep = this.state.cep.replace(/\D/g, "");
    let aluno = this.props.navigation.getParam("aluno");

    try {
      const response = await buscaViaCep(cep);

      let endereco = await response.json();
      if (!response.ok || endereco.erro) {
        this.setState({ ...this.state, loading: false });

        this.setState({ cep: "" });
        return alert(
          "Ops...",
          "Houve algum problema ao pesquisar, verifique o cep e tente novamente"
        );
      }

      endereco = enderecoFormat(endereco);

      this.setState({ endereco, showConfirm: true, loading: false });

      Keyboard.dismiss();
    } catch (erro) {
      this.setState({ ...this.state, loading: false });

      console.log(erro);
      alert(
        "Ops...",
        "Houve um problema ao consultar, verifique o cep e tente novamente"
      );
    }
  };

  handlerCep = async (e) => {
    await this.setState({ cep: e });
    if (e.length == 9) {
      Keyboard.dismiss();
      this.buscaCep();
    }
  };

  salvar = async () => {
    this.setState({ ...this.state, loading: true });

    let { endereco } = this.state;
    const aluno = this.props.navigation.getParam("aluno");

    delete endereco.logradouro;

    let alunoAtualizar = {
      cpf: aluno.cpf,
      ...endereco,
    };

    try {
      const response = await atualizarAluno(alunoAtualizar);

      const endereco = await response.json();
      if (!response.ok) {
        this.setState({ loading: false });
        return alert(
          "Ops...",
          "Houve algum problema, tente novamente mais tarde"
        );
      }

      this.setState({ ...this.state, loading: false });

      Keyboard.dismiss();
      EventRegister.emit("reloadPerfil", "it works!!!");
      this.props.navigation.pop(1);
    } catch (erro) {
      this.setState({ ...this.state, loading: false });

      console.log(erro);
      alert(
        "Ops...",
        "Houve um problema ao consultar, verifique o numero e tente novamente"
      );
    }
  };

  render() {
    const aluno = this.props.navigation.getParam("aluno");
    const { endereco } = this.state;
    return (
      <>
        {this.state.loading && <Loading />}
        <KeyboardAvoidingView
          style={styles.container}
          behavior={Platform.select({
            ios: "padding",
            android: "null",
          })}
          keyboardVerticalOffset={Platform.select({ ios: 64, android: 0 })}
        >
          <ImageBackground
            source={require("../../../resources/imgs/bg.jpg")}
            style={styles.container}
            imageStyle={styles.imageContainer}
          >
            <View style={[styles.containerForm, { paddingBottom: 55 }]}>
              <ScrollView
                style={{ height: 100, width: "100%" }}
                contentContainerStyle={{
                  alignItems: "center",
                  paddingHorizontal: 10,
                }}
              >
                <Text style={styles.textHeader1}>
                  Por favor, informe o cep da sua residência:
                </Text>
                <TextInputMask
                  type={"custom"}
                  ref={(input) => (this.inputCpf = input)}
                  options={{ mask: "99999-999", maskType: "INTERNATIONAL" }}
                  style={styles.input}
                  placeholder="Seu CEP..."
                  keyboardType="phone-pad"
                  placeholderTextColor="#ccc"
                  maxLength={10}
                  value={this.state.cep}
                  onFocus={() =>
                    this.setState({ endereco: {}, showConfirm: false })
                  }
                  onChangeText={this.handlerCep}
                />
                <ConfirmaEndereco endereco={endereco} />
              </ScrollView>
            </View>
          </ImageBackground>
          {this.state.showConfirm && (
            <ButtonConfirm
              text={"Sim"}
              disabled={!this.state.showConfirm}
              onPress={this.salvar}
              msgDisabled={""}
            />
          )}
        </KeyboardAvoidingView>
      </>
    );
  }
}

export default EditarEndereco;
